export default __webpack_public_path__ + "fe31c68185bbc82c37a8aa0971eebb19.png";